import _flexbox from "../dict/flexbox.js";
import _ttmlFunc from "../functions/profiles/ttmlGeneral.js";
import { XMLParser as _XMLParser } from "fast-xml-parser";
import _eol from "eol";
import _convertToPlainTextCustom from "../functions/quill/convertToPlainTextCustom.js";
import _getFormatOptions from "../functions/helpers/getFormatOptions.js";
import _removeInvalidEvents from "../functions/eventGroups/removeInvalidEvents.js";
const removeInvalidEvents = _removeInvalidEvents;
const getFormatOptions = _getFormatOptions;
const convertToPlainTextCustom = _convertToPlainTextCustom;
const eol = _eol;
const XMLParser = _XMLParser;
const ttmlFunc = _ttmlFunc;
const flexbox = _flexbox;
function mapTextAlign(alignment) {
  return flexbox.alignmentMap[alignment] || "center";
}
function isTopPosition(yPos) {
  return yPos === "start" || yPos === "top";
}
function resolveRegionId(event) {
  return isTopPosition(event.yPos) ? "speakerTop" : "speaker";
}
function applyBroadstreamRegionPosition(ccEvent, regionId) {
  if (regionId === "speakerTop" || regionId === "backgroundTop") {
    ccEvent.yPos = "start";
  } else if (regionId === "speaker" || regionId === "background") {
    ccEvent.yPos = "end";
  }
  return ccEvent;
}
function decorateSpans(html, textAlign, defaultColor) {
  return html.replace(/<span([^>]*)>/gi, (match, attrs) => {
    let color = defaultColor;
    const colorMatch = attrs.match(/\stts:color\s*=\s*['"]([^'"]+)['"]/i);
    if (colorMatch) {
      color = colorMatch[1];
    } else {
      const styleColorMatch = attrs.match(/\sstyle\s*=\s*['"][^'"]*color:\s*([^;'"]+)/i);
      if (styleColorMatch) {
        color = styleColorMatch[1].trim();
      }
    }
    let newAttrs = attrs.replace(/\s*tts:textAlign\s*=\s*['"][^'"]*['"]/gi, "").replace(/\s*tts:color\s*=\s*['"][^'"]*['"]/gi, "").replace(/\s*tts:backgroundColor\s*=\s*['"][^'"]*['"]/gi, "");
    return `<span tts:textAlign="${textAlign}" tts:color="${color}" tts:backgroundColor="black"${newAttrs}>`;
  });
}
function wrapLineInSpan(line, textAlign, defaultColor) {
  line = line.trim();
  if (!line) {
    return "";
  }
  if (/<span[\s>]/i.test(line)) {
    return decorateSpans(line, textAlign, defaultColor);
  }
  return `<span tts:textAlign="${textAlign}" tts:color="${defaultColor}" tts:backgroundColor="black">${line}</span>`;
}
function formatEventText(event, defaultColor) {
  const textAlign = mapTextAlign(event.alignment);
  const plainTextCustom = convertToPlainTextCustom(event.text, "\n", false, "strong", "em", "u", true);
  const ttmlText = ttmlFunc.multiLine.convertToTtml(plainTextCustom);
  const lines = ttmlText.split(/<br\s*\/?>/i);
  return lines.map(line => wrapLineInSpan(line, textAlign, defaultColor)).filter(Boolean).join("<br />");
}
export default {
  decode: function (input, options) {
    let events = [],
      regions = [],
      styles = [],
      region,
      style;
    const xmlToJson = new XMLParser({
      stopNodes: ["*.p"],
      numberParseOptions: {
        skipLike: /[0-9]+/
      },
      ignoreAttributes: false
    });
    let fileJson = xmlToJson.parse(input);
    if (!fileJson.tt) {
      fileJson = {
        tt: fileJson
      };
    }

    /* Broadstream uses ms clock times even when ttp:timeBase is smpte */
    const useClockTime = true;
    if (fileJson.tt.head.layout && fileJson.tt.head.layout.region) {
      if (Array.isArray(fileJson.tt.head.layout.region)) {
        regions = fileJson.tt.head.layout.region;
      } else {
        regions = [fileJson.tt.head.layout.region];
      }
    }
    if (fileJson.tt.head.styling && fileJson.tt.head.styling.style) {
      if (Array.isArray(fileJson.tt.head.styling.style)) {
        styles = fileJson.tt.head.styling.style;
      } else {
        styles = [fileJson.tt.head.styling.style];
      }
    }
    const pushParagraph = paragraph => {
      region = paragraph["@_region"] ? regions.find(regionEl => regionEl["@_xml:id"] === paragraph["@_region"]) : false;
      style = paragraph["@_style"] ? styles.find(styleEl => styleEl["@_xml:id"] === paragraph["@_style"]) : false;
      let ccEvent = ttmlFunc.multiLine.decodeSubtitle(paragraph, region, style, options.frameRate, options.dropFrame, useClockTime, options.window);
      events.push(applyBroadstreamRegionPosition(ccEvent, paragraph["@_region"]));
    };
    if (Array.isArray(fileJson.tt.body.div)) {
      fileJson.tt.body.div.forEach(paragraphGroup => {
        if (Array.isArray(paragraphGroup.p)) {
          paragraphGroup.p.forEach(pushParagraph);
        } else {
          pushParagraph(paragraphGroup.p);
        }
      });
    } else if (Array.isArray(fileJson.tt.body.div.p)) {
      fileJson.tt.body.div.p.forEach(pushParagraph);
    } else {
      pushParagraph(fileJson.tt.body.div.p);
    }
    return events;
  },
  encode: function (eventGroup, options) {
    let encodingOptions = getFormatOptions(options.formatOptions);
    let languageCode = encodingOptions["Language Code"] || "en";
    let fontFamily = encodingOptions["Font Family"] || "Arial";
    let fontSize = encodingOptions["Font Size"] || "18px";
    let fontStyle = encodingOptions["Font Style"] || "normal";
    let color = encodingOptions["Color"] || "#FFFFFF";
    let backgroundColor = encodingOptions["Background Color"] || "rgba(0,0,0,0)";
    let textOutline = encodingOptions["Text Outline"] || "#000000 1px 1px";
    let frameRateMultiplier = ttmlFunc.frameRateMultiplierMap[options.frameRate];
    let dropMode = options.dropFrame ? "dropNTSC" : "nonDrop";
    let output = eol.after(`<?xml version="1.0" encoding="UTF-8"?>`);
    output += eol.after(`<tt xmlns="http://www.w3.org/ns/ttml" xmlns:ttp="http://www.w3.org/ns/ttml#parameter" xmlns:tts="http://www.w3.org/ns/ttml#styling" xmlns:ttm="http://www.w3.org/ns/ttml#metadata" xmlns:itts="http://www.w3.org/ns/ttml/profile/imsc1#styling" xml:lang="${languageCode}" ttp:timeBase="smpte" ttp:frameRate="${ttmlFunc.frameRateMap[options.frameRate]}" ttp:frameRateMultiplier="${frameRateMultiplier}" ttp:dropMode="${dropMode}">`);
    output += eol.after(`<head>`);
    output += eol.after(`<metadata>`);
    output += eol.after(`<ttm:copyright>BroadStream Solutions</ttm:copyright>`);
    output += eol.after(`</metadata>`);
    output += eol.after(`<styling>`);
    output += eol.after(`<!--s1 specifies default color, font, and text alignment-->`);
    output += eol.after(`<style xml:id="backgroundStyle" tts:backgroundColor="${backgroundColor}" tts:displayAlign="after" tts:extent="100% 30%" tts:origin="0% 50%" tts:fontFamily="${fontFamily}" tts:fontSize="${fontSize}" tts:fontStyle="${fontStyle}" tts:textAlign="center" />`);
    output += eol.after(`<style xml:id="speakerStyle" tts:backgroundColor="${backgroundColor}" tts:color="${color}" tts:textOutline="${textOutline}" style="backgroundStyle" />`);
    output += eol.after(`<style xml:id="backgroundStyleTop" tts:backgroundColor="${backgroundColor}" tts:displayAlign="before" tts:extent="100% 30%" tts:origin="0% 10%" tts:fontFamily="${fontFamily}" tts:fontSize="${fontSize}" tts:fontStyle="${fontStyle}" tts:textAlign="center" />`);
    output += eol.after(`<style xml:id="speakerStyleTop" tts:backgroundColor="${backgroundColor}" tts:color="${color}" tts:textOutline="${textOutline}" style="backgroundStyleTop" />`);
    output += eol.after(`</styling>`);
    output += eol.after(`<layout>`);
    output += eol.after(`<region xml:id="speaker" style="speakerStyle" tts:zIndex="1" />`);
    output += eol.after(`<region xml:id="background" style="backgroundStyle" tts:zIndex="0" />`);
    output += eol.after(`<region xml:id="speakerTop" style="speakerStyleTop" tts:zIndex="3" />`);
    output += eol.after(`<region xml:id="backgroundTop" style="backgroundStyleTop" tts:zIndex="2" />`);
    output += eol.after(`</layout>`);
    output += eol.after(`</head>`);
    output += eol.after(`<body>`);
    output += eol.after(`<div>`);
    eventGroup.events.forEach(event => {
      let start = event.startMsIncode.replace(",", ".");
      let end = event.endMsIncode.replace(",", ".");
      let regionId = resolveRegionId(event);
      let text = formatEventText(event, color);
      output += eol.after(`<p begin="${start}" end="${end}" region="${regionId}">${text}</p>`);
    });
    output += eol.after(`</div>`);
    output += eol.after(`</body>`);
    output += `</tt>`;
    return eol.auto(output);
  },
  preProcess: {
    encode: function (eventGroup) {
      return removeInvalidEvents(eventGroup);
    },
    decode: function (input) {
      return eol.lf(input);
    }
  },
  postProcess: {
    encode: function (output) {
      return output;
    },
    decode: function (eventGroup) {
      return eventGroup;
    }
  }
};